<!--
 * @Author: p_fy
 * @Date: 2019-06-22 15:10:28
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:23:05
 * @Description: 普仓供给查询条件页面。
 -->
<template>
  <div class="transport-news">
    <div class="main-wrap">
      <div class="main">
        <el-form ref="form" :model="form" :label-position="'left'" label-width="5rem">
          <el-form-item class="selected-conditions" label="已选:">
            <el-tag
              v-for="tag in conditionsList"
              :key="tag.text"
              class="main-color"
              :disable-transitions="true"
              closable
              @close="conditionsClose(tag)"
            >{{ tag.text }}</el-tag>
            <div class="clear-conditions" @click="clearAllConditions">
              <i class="el-icon-delete" />清空已选条件
            </div>
          </el-form-item>

          <el-form-item label="租单名称:">
            <el-input
              v-model="form.supplyName.data.item.label"
              placeholder="请输入内容"
              style="width: 44.3%;"
            />
          </el-form-item>

          <el-form-item label="仓库位置:">
            <el-cascader
              v-model="startAreaText"
              :options="area"
              :filterable="true"
              class="startAreaText"
              :props="{ expandTrigger: 'hover' ,
                        checkStrictly: true}"
              style="width: 44.3%;"
              @expand-change="expandChange"
            />
            <!-- @change="startAreaTextWidth" -->
          </el-form-item>

          <el-form-item label="起租日期:">
            <div class="transport-data">
              <el-date-picker
                v-model="form.leaseTime.data.startLeaseTime.label"
                :picker-options="pickerOptions"
                :editable="false"
                :value-format="dateValueFormat"
                type="datetime"
                align="right"
                @change="startLeaseDateChange"
              />
              <div class="des">
                <span>-</span>
              </div>
              <el-date-picker
                v-model="form.leaseTime.data.endLeaseTime.label"
                :picker-options="pickerOptions2"
                :value-format="dateValueFormat"
                :editable="false"
                type="datetime"
                align="right"
                @change="showSelectedConditions"
              />
            </div>
          </el-form-item>

          <el-form-item label="仓库类型:">
            <el-checkbox-group v-model="warehouseTypeList">
              <el-checkbox-button
                v-for="city in storageType.warehouseType"
                :key="city.label"
                :label="`{&quot;label&quot;:&quot;${city.label}&quot;,&quot;value&quot;:&quot;${city.value}&quot;}`"
              >{{ city.label }}</el-checkbox-button>
              <!-- <el-checkbox-button label="{&quot;label&quot;:&quot;楼房仓库&quot;,&quot;value&quot;:&quot;2&quot;}">楼房仓库</el-checkbox-button>
              <el-checkbox-button label="{&quot;label&quot;:&quot;简易仓库&quot;,&quot;value&quot;:&quot;3&quot;}">简易仓库</el-checkbox-button>-->
            </el-checkbox-group>
          </el-form-item>

          <el-form-item class="capacity-content" label="仓库面积:">
            <el-radio-group v-model="coveredAreaText">
              <el-radio-button
                label="{&quot;label&quot;:&quot;100m²以下&quot;,&quot;value&quot;:&quot;0—100&quot;}"
              >100m²以下</el-radio-button>
              <el-radio-button
                label="{&quot;label&quot;:&quot;100—500m²&quot;,&quot;value&quot;:&quot;100—500&quot;}"
              >100—500m²</el-radio-button>
              <el-radio-button
                label="{&quot;label&quot;:&quot;500—2000m²&quot;,&quot;value&quot;:&quot;500—2000&quot;}"
              >500—2000m²</el-radio-button>
              <el-radio-button
                label="{&quot;label&quot;:&quot;2000m²以上&quot;,&quot;value&quot;:&quot;2000—0&quot;}"
              >2000m²以上</el-radio-button>
            </el-radio-group>
            <el-input v-model="coveredAreaStart" @change="startChange" />
            <div class="des">
              <span>——</span>
            </div>
            <el-input v-model="coveredAreaEnd" @change="endChange" />
            <el-button class="el-button-ml" @click="changeCoveredWithCustom">确定</el-button>
          </el-form-item>

          <el-form-item label="储存品类:">
            <el-checkbox-group v-model="storageTypeList">
              <el-checkbox-button
                v-for="city in storageType.storageType"
                :key="city.label"
                :label="`{&quot;label&quot;:&quot;${city.label}&quot;,&quot;value&quot;:&quot;${city.value}&quot;}`"
              >{{ city.label }}</el-checkbox-button>
              <!-- <el-checkbox-button label="{&quot;label&quot;:&quot;成品油&quot;,&quot;value&quot;:&quot;2&quot;}">成品油 </el-checkbox-button>
              <el-checkbox-button label="{&quot;label&quot;:&quot;液化石油气&quot;,&quot;value&quot;:&quot;3&quot;}">液化石油气</el-checkbox-button>
              <el-checkbox-button label="{&quot;label&quot;:&quot;润滑油&quot;,&quot;value&quot;:&quot;4&quot;}">润滑油</el-checkbox-button>
              <el-checkbox-button label="{&quot;label&quot;:&quot;固态化工品&quot;,&quot;value&quot;:&quot;5&quot;}">固态化工品</el-checkbox-button>-->
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="demand-button">
        <el-button
          class="el-button-ml demand-but active"
          @click="openShowSupply('TtorageSupplyInfo')"
        >普通仓库</el-button>
        <el-button class="el-button-ml demand-but" @click="openShowSupply('TankSupplyInfo')">罐区</el-button>
      </div>

      <!--表格 -->
      <div class="table-wrap">
        <storage-supply
          ref="storageSupply"
          :params="param"
          @favorites="favorites"
          @order="order"
          @deal="deal"
        />
      </div>
      <order-warehousing
        ref="orderDialog"
        order-type="1"
        :order-manager="orderManager.visible"
        :order-data="orderManager.data"
        @close="orderManager.close"
      />
      <store-deal
        ref="dealDialog"
        deal-type="1"
        :deal-manager="dealManager.visible"
        :deal-data="dealManager.data"
        :demand-data="null"
        @close="dealManager.close"
        @closeSuccess="dealManager.close"
      />
      <!-- 平台协议 -->
      <el-dialog :visible.sync="platform" width="600px" title="成交订单">
        <el-form ref="offerForm">
          <div class="con" v-html="platformTxt">
            <!--<p class="con-title">平台报价规则如下：</p>-->
            <!--<div class="con-box">-->
            <!--<p>1.权利人的姓名(名称)、联系方式、地址、身份证扫揎件(自然人)、企业法人营业执照(单位)、法定代表人身份证明(单位</p>-->
            <!--<p>2.要求删除或者断开链接的侵权作品的淮确名称和网络地址,以便干图网能够发现并初步审核涉嫌侵权作品。</p>-->
            <!--<p>3.认为构成侵权的初步证明材料,包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明,以及涉嫌侵权作品侵权事实的举证。</p>-->
            <!--<p>4.通知书需由权利人或其合法授权人亲笔签名,若为单位则需加盖单位公章</p>-->
            <!--</div>-->
          </div>
          <el-checkbox v-model="checkedRule">我同意以上规则</el-checkbox>
          <el-checkbox v-model="checkedRemind">以后不再提醒</el-checkbox>
          <!--<el-checkbox v-model="checkedRule"></el-checkbox>-->
          <div class="form-line">
            <el-form-item>
              <el-button class="quotation-form-btn quotation-btn" :class="{'quotation-btn-xz': !checkedRule}" @click="nexStep">下一步</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// import { addressArrToString } from '@/utils/utils.js'
import storageSupplyItems from './components/storageSupplyItems'
import orderWarehousing from '../components/orderWarehousing'
import storeDeal from '../../personal/store/components/storeDeal'
import {
  conllection,
  getArea,
  getDict,
  findCmsPlatformProtocol,
  upateStatus
} from '@/api/cloud/storage-supply-info/storageSupplyInfo'
import { isNormalString } from '@/utils/validate'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()

export default {
  name: 'StorageSupplyInfo',
  components: {
    'storage-supply': storageSupplyItems,
    'order-warehousing': orderWarehousing,
    storeDeal
  },
  data() {
    return {
      // 平台规则弹窗状态
      platform: false,
      // 是否同意规则
      checkedRule: false,
      // 是否不再提示平台规则
      checkedRemind: false,
      platformTxt: '',
      // 当前查询条件列表
      conditionsList: [],
      areaList: new Map(),
      storageType: {
        storageType: [],
        warehouseType: []
      },
      dateValueFormat: 'yyyy-MM-dd HH:mm:ss',
      orderManager: {
        visible: false,
        data: {},
        close: () => {
          this.onSubmit()
          this.orderManager.visible = false
        }
      },
      dealManager: {
        visible: false,
        data: {},
        close: () => {
          this.onSubmit()
          this.dealManager.visible = false
        }
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate: (time) => {
          const beginDateVal = new Date(this.form.leaseTime.data.startLeaseTime.label)
          if (beginDateVal) {
            return time.getTime() <= beginDateVal.getTime() - 1000 * 60 * 60 * 24
          } else {
            return time.getTime() < new Date().getTime()
          }
        }
      },
      area: [],
      // 仓库地址
      startAreaText: '',
      // 建筑面积的文本,用以绑定
      coveredAreaText: { value: '0—0' },
      // 建筑面积的文本,用以绑定输入框
      coveredAreaStart: '',
      coveredAreaEnd: '',
      startAreaParam: '',
      // 仓库类型的lisy 用以绑定
      warehouseTypeList: [],
      // 货物类型的lisy 用以绑定
      storageTypeList: [],
      form: {
        storageLocation: {
          name: '仓储位置:',
          data: {}
        },
        supplyName: {
          name: '租单名称:',
          data: { item: { label: '' }}
        },
        leaseTime: {
          name: '起租日期:',
          data: {
            startLeaseTime: {
              name: '起租开始时间:',
              label: ''
            },
            endLeaseTime: {
              name: '起租结束时间:',
              label: ''
            }
          }
        },
        warehouseType: {
          name: '仓库类型:',
          data: []
        },
        coveredArea: {
          name: '仓库面积:',
          data: { item: { value: '' }}
        },
        capacity: {
          name: '重量:',
          data: { item: { value: '0—0' }}
        },
        storageType: {
          name: '储存品类:',
          data: []
        }
      },
      // 列表数据
      listData: [],
      param: {}
    }
  },
  watch: {
    startAreaText: {
      handler: function(val) {
        console.log('val', val)
        if (JSON.stringify(val) !== '[]') {
          var startArea = val
          this.startAreaParam = startArea.join('#')
          var areMap = this.areaList
          var obj = []
          for (let i = 0; i < startArea.length; i++) {
            areMap.forEach(function(item, key, mapObj) {
              if (item.areaCode == startArea[i]) {
                obj.push(item)
              }
            })
          }
          console.log('obj', obj)
          this.form.storageLocation.data = obj
        }
      }
    },
    'form.storageLocation.data': {
      handler: function(val) {
        if (JSON.stringify(val) === '[]') {
          this.startAreaText = []
          this.startAreaParam = ''
        }
        this.showSelectedConditions()
      }
    },
    'form.supplyName.data.item.label': {
      handler: function(val) {
        var reg = isNormalString(val)
        // var reg = this.$character(1, 20, 'regular')
        if (!this.isEmpty(val) && !reg) {
          this.form.supplyName.data.item.label = ''
        } else {
          this.showSelectedConditions()
        }
      }
    },
    'form.leaseTime.data.startLeaseTime.label': {
      handler: function(val) {
        this.startLeaseDateChange()
        this.showSelectedConditions()
      }
    },
    'form.leaseTime.data.endLeaseTime.label': {
      handler: function(val) {
        if (new Date(this.form.leaseTime.data.startLeaseTime.label).getTime() > new Date(val).getTime()) {
          this.form.leaseTime.data.endLeaseTime = {
            name: '起租结束时间:', label: ''
          }
        }
        this.showSelectedConditions()
      }
    },
    coveredAreaText: {
      handler: function(val) {
        if (JSON.stringify(val) !== '{"value":"0—0"}') {
          this.form.coveredArea.data.item = JSON.parse(val)
        } else {
          this.form.coveredArea.data.item = { value: '0—0' }
        }
        this.showSelectedConditions()
      }
    },
    'form.coveredArea.data.item': {
      handler: function(val) {
        var text
        if (JSON.stringify(this.coveredAreaText) !== '{"value":"0—0"}') {
          text = JSON.stringify(JSON.parse(this.coveredAreaText))
        } else {
          text = JSON.stringify(this.coveredAreaText)
        }
        if (JSON.stringify(val) !== text) {
          this.coveredAreaStart = ''
          this.coveredAreaEnd = ''
          this.coveredAreaText = { value: '0—0' }
        }
      }
    },
    warehouseTypeList: {
      handler: function(val) {
        this.form.warehouseType.data.length = 0
        if (this.form.warehouseType.data !== val) {
          for (let i = 0; i < val.length; i++) {
            if (typeof val[i] === 'string') {
              this.form.warehouseType.data[i] = JSON.parse(
                JSON.parse(JSON.stringify(val[i]))
              )
            }
          }
          this.showSelectedConditions()
        }
      }
    },
    'form.warehouseType.data': {
      handler: function(val) {
        if (this.warehouseTypeList !== val) {
          this.warehouseTypeList = []
        }
      }
    },
    storageTypeList: {
      handler: function(val) {
        this.form.storageType.data.length = 0
        if (this.form.storageType.data !== val) {
          for (let i = 0; i < val.length; i++) {
            if (typeof val[i] === 'string') {
              this.form.storageType.data[i] = JSON.parse(
                JSON.parse(JSON.stringify(val[i]))
              )
            }
          }
          this.showSelectedConditions()
        }
      }
    },
    'form.storageType.data': {
      handler: function(val) {
        if (this.storageTypeList !== val) {
          this.storageTypeList = []
        }
      }
    },
    tableData: {
      handler: function(val) {
        this.tableData = val
      },
      immediate: true,
      deep: true
    },
    coveredAreaStart: {
      handler: function(val) {
        if (this.coveredAreaEnd) {
          // this.coveredAreaText = { value: '0—0' }
        }
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.coveredAreaEnd)) {
          // this.coveredAreaEnd = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          // this.coveredAreaStart = ''
        } else {
          if (
            parseFloat(this.coveredAreaStart) > parseFloat(this.coveredAreaEnd)
          ) {
            // this.coveredAreaEnd = 1
          }
        }
      }
    },
    coveredAreaEnd: {
      handler: function(val) {
        if (this.coveredAreaEnd) {
          // this.coveredAreaText = { value: '0—0' }
        }
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.coveredAreaStart)) {
          // this.coveredAreaStart = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          // this.coveredAreaEnd = ''
        }
      }
    }
  },
  created() {
    (async() => {
      await this.getArea()
      await this.getStorageType()
      await this.getWarehouseType()
    })()
  },
  methods: {
    // 仓库面积范围
    startChange(val) {
      // if (
      //   !this.isEmpty(this.queryParams.coveredAreaEnd) &&
      //   this.isEmpty(this.queryParams.coveredAreaStart)
      // ) {
      //   this.queryParams.coveredAreaStart = ''
      // }
    },
    // 仓库面积范围
    endChange(val) {
      // if (
      //   !this.isEmpty(this.queryParams.coveredAreaStart) &&
      //   this.isEmpty      eryParams.coveredAreaEnd)
      // ) {
      //   this.queryParams.coveredAreaEnd = ''
      // }
      // if (parseFloat(this.coveredAreaStart) > parseFloat(this.coveredAreaEnd)) {
      // this.coveredAreaEnd = 1
      // }
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 选择开始时间，清空结束时间
    startLeaseDateChange(date) {
      this.form.leaseTime.data.endLeaseTime.label = ''
      this.pickerOptions = {
        // disabledDate(time) {
        //   // 开始时间-结束时间
        //   return time.getTime() < new Date(date).getTime()
        // }
      }
      this.showSelectedConditions()
    },
    // 页面跳转
    openShowSupply(name) {
      this.$router.push({ name: name })
    },
    // 获取地址字典
    getArea() {
      this.getLocalStorageUtil('area')
        .then(data => {
          this.area = data
          this.formatArea(100000, this.area)
          console.log('1111111111',data)
        })
        .catch(() => {
          getArea()
            .then(data => {
              this.area = data.result
              this.setLocalStorageUtil('area', data.result)
              this.formatArea(100000, this.area)
            })
            .catch(error => {
              console.error(error)
            })
        })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType')
        .then(storageType => {
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('storageType')
            .then(res => {
              const storageType = JSON.parse(res.result)
              this.setLocalStorageUtil('storageType', storageType)
              if (storageType.length > 0) {
                storageType.forEach(res => {
                  this.storageType.storageType.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 仓库类型字典
    getWarehouseType() {
      this.getLocalStorageUtil('warehouseType')
        .then(warehouseType => {
          if (warehouseType.length > 0) {
            warehouseType.forEach(res => {
              this.storageType.warehouseType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('warehouseType')
            .then(res => {
              const warehouseType = JSON.parse(res.result)
              this.setLocalStorageUtil('warehouseType', warehouseType)
              if (warehouseType.length > 0) {
                warehouseType.forEach(res => {
                  this.storageType.warehouseType.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 地址字典内容整理
    formatArea(parent, data) {
      for (var key in data) {
        if (data[key].parentCode == parent) {
          this.areaList.set(data[key].areaCode, data[key])
          if (data[key].children && data[key].children.length > 0) {
            this.formatArea(data[key].areaCode, data[key].children)
          }
        }
      }
    },
    // 预约看仓
    order(supply) {
      // appointment({ supplyId: supply.id, contactMan: supply.linkMan, tel: supply.telephone, demandType: '1' }).then(res => {
      this.orderManager.data = supply
      this.orderManager.visible = true
      // supply.appointmentStatus = '1'
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    // 成交
    deal(item) {
      this.dealManager.data = item
      const con = {
        type: 3,
        location: 1
      }
      findCmsPlatformProtocol(con).then(res => {
        if (res.result.length < 1) {
          this.dealManager.visible = true
        } else {
          this.platform = true
          this.platformTxt = res.result[0].content
        }
      })
    },
    // 平台协议下一步
    nexStep(data) {
      if (this.checkedRule) {
        let showIf = false
        if (this.checkedRule == true) {
          showIf = 0
        } else {
          showIf = 1
        }
        const con = {
          type: 3,
          location: 1,
          status: showIf
        }
        this.platform = false
        this.dealManager.visible = true
        upateStatus(con).then(res => {
          console.log(res)
        })
      } else {
        this.$message({
          message: '未同意以上规则！',
          type: 'warning'
        })
      }
    },
    clearAllConditions() {
      this.conditionsList = []
      const obj = this.form
      for (const prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
          continue
        }
        if (
          Object.prototype.toString.call(obj[prop].data) === '[object Array]'
        ) {
          obj[prop].data = []
        } else {
          // 清空子类data
          for (const child in obj[prop].data) {
            if (!obj[prop].data.hasOwnProperty(child)) {
              continue
            }
            obj[prop].data[child] = this.setRemItme(prop, child)
          }
        }
      }
      this.onSubmit()
    },
    // 删掉tag的时候清除掉form对象中对应的条件
    conditionsClose(tag) {
      this.conditionsList.splice(this.conditionsList.indexOf(tag), 1)
      const obj = this.form
      for (const prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
          continue
        }
        const item = obj[prop]
        if (item.name === tag.name) {
          if (
            Object.prototype.toString.call(obj[prop].data) === '[object Array]'
          ) {
            obj[prop].data = []
          } else {
            // 清空子类data
            for (const child in obj[prop].data) {
              if (!obj[prop].data.hasOwnProperty(child)) {
                continue
              }
              obj[prop].data[child] = this.setRemItme(prop, child)
            }
          }
        }
      }
    },
    setRemItme(propTag, tag) {
      const obj = {
        storageLocation: {
          name: '仓储位置:',
          data: {}
        },
        supplyName: {
          name: '租单名称:',
          data: { item: { label: '' }}
        },
        leaseTime: {
          name: '起租日期:',
          data: {
            startLeaseTime: {
              name: '起租开始时间:',
              label: ''
            },
            endLeaseTime: {
              name: '起租结束时间:',
              label: ''
            }
          }
        },
        warehouseType: {
          name: '仓库类型:',
          data: []
        },
        coveredArea: {
          name: '仓库面积:',
          data: { item: { value: '' }}
        },
        capacity: {
          name: '重量:',
          data: { item: { value: '0—0' }}
        },
        storageType: {
          name: '储存品类:',
          data: []
        }
      }
      for (const prop in obj) {
        if (propTag == prop) {
          // 清空子类data
          for (const child in obj[prop].data) {
            if (tag == child) {
              return obj[prop].data[child]
            }
          }
        }
      }
      return {}
    },
    showSelectedConditions() {
      const $this = this
      const obj = this.form
      $this.conditionsList = []

      for (var prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
          continue
        }
        const item = obj[prop]
        const itemData = obj[prop].data

        // 如果为数组
        if (Object.prototype.toString.call(itemData) === '[object Array]') {
          let n = 0
          n += itemData.length || 0
          let string = ''
          for (let i = 0; i < n; i++) {
            string += itemData[i].label + '/'
          }
          string = string.substring(0, string.length - 1)
          // 如果对象查询条件不为空
          if (string !== '') {
            $this.conditionsList.push({
              name: item.name,
              text: item.name + string
            })
          }
        } else {
          // 如果为对象
          let string = ''
          Object.keys(itemData).forEach(function(itemKey) {
            if (itemData[itemKey].label) {
              string += itemData[itemKey].label + '-'
            }
          })
          string = string.substring(0, string.length - 1)
          // 如果对象查询条件不为空
          if (string !== '') {
            $this.conditionsList.push({
              name: item.name,
              text: item.name + string
            })
          }
        }
      }
      this.onSubmit()
    },
    changeCoveredWithCustom() {
      if (this.coveredAreaStart === '') {
        this.$message({
          offset: 100,
          message: '请输入普仓面积范围!',
          type: 'warning'
        })
        return false
      }
      if (this.coveredAreaEnd === '') {
        this.$message({
          offset: 100,
          message: '请输入普仓面积范围!',
          type: 'warning'
        })
        return false
      }
      if (parseInt(this.coveredAreaStart) > parseInt(this.coveredAreaEnd)) {
        this.$message({
          offset: 100,
          message: '普仓面积不可大于起始普仓面积范围!',
          type: 'warning'
        })
        return false
      }
      const coveredArea = this.coveredAreaStart + '—' + this.coveredAreaEnd
      // 触发watch
      this.coveredAreaText = {}
      this.coveredAreaText = JSON.stringify({
        label: coveredArea + 'm²',
        value: coveredArea
      })
    },
    // 收藏
    favorites(item) {
      // 重复点击
      if (item.collectionSubmit) {
        return false
      }
      item.collectionSubmit = true
      const collStatus = item.collectionStatus == '1' ? '2' : '1'
      // 发起收藏?取消收藏的请求
      conllection({
        id: item.collectionId,
        moduleId: item.id,
        moduleType: '5',
        collectionStatus: collStatus
      })
        .then(data => {
          item.collectionStatus = collStatus
          item.collectionId = data.result.id
          this.$message({
            offset: 100,
            message: item.collectionStatus == '1' ? '收藏成功' : '取消收藏成功',
            type: item.collectionStatus == '1' ? 'success' : 'warning'
          })
          item.collectionSubmit = false
        })
        .catch(error => {
          console.error(error)
          item.collectionSubmit = false
        })
    },
    // 修改查询条件后触发查询
    onSubmit() {
        // 将查询条件绑定到页面的参数属性值上
        if (this.form.storageLocation.data.length > 0) {
          const storageLocation = []
          this.form.storageLocation.data.forEach(res => {
       
            storageLocation.push(res.areaCode)
          })
          this.param.storageLocation = storageLocation.join('#')
        } else {
          this.param.storageLocation = null
        }
        if (this.form.demandName.data.item.label != '') {
          this.param.demandName = this.form.demandName.data.item.label
        } else {
          this.param.demandName = null
        }
        if (this.form.leaseTime.data.startLeaseTime.label != '') {
          this.param.leaseStartTime = this.form.leaseTime.data.startLeaseTime.label
        } else {
          this.param.leaseStartTime = null
        }
        if (this.form.leaseTime.data.endLeaseTime.label != '') {
          this.param.leaseEndTime = this.form.leaseTime.data.endLeaseTime.label
        } else {
          this.param.leaseEndTime = null
        }
        if (this.form.warehouseType.data.length > 0) {
          const warehouseType = []
          this.form.warehouseType.data.forEach(res => {
            warehouseType.push(res.value)
          })
          this.param.warehouseType = warehouseType.join(',')
        } else {
          this.param.warehouseType = null
        }
        if (this.form.coveredArea.data.item.value != '') {
          const rentableStartArea = this.form.coveredArea.data.item.value.split('—')
          this.param.demandStartArea = rentableStartArea[0]
          this.param.demandEndArea = rentableStartArea[1]
        } else {
          this.param.rentableStartArea = null
        }
        if (this.form.storageType.data.length > 0) {
          const storageType = []
          this.form.storageType.data.forEach(res => {
            storageType.push(res.value)
          })
          this.param.storageType = storageType.join(',')
        } else {
          this.param.storageType = null
        }
      this.$refs.storageSupply.loadData()
      console.log(JSON.stringify(this.param))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText =
              'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    }
    // startAreaTextWidth(val) {
    //   setTimeout(function() {
    //     var startAreaText = document.getElementsByClassName('startAreaText')
    //     startAreaText[0].querySelector('input').style.width = '0px'
    //     var areaWidth = startAreaText[0].querySelector('input').scrollWidth
    //     // alert(areaWidth)
    //     startAreaText[0].querySelector('input').style.width = parseInt(areaWidth) <= 218 ? 218 + 'px' : (parseInt(areaWidth) + 25) + 'px'
    //   }, 100)
    // }
  }
}
</script>

<style scoped lang='scss'>
.transport-news {
  margin-bottom: 1rem;
}
.demand-button {
  width: 1200px;
  margin: 0 auto 1rem;
  .demand-but {
    width: 106px;
    height: 40px;
    border: 1px solid rgba(190, 35, 22, 1);
    color: #be2316;
    border-radius: 4px;
    &:active {
      background: rgba(190, 35, 22, 1);
      color: #f6f6f6;
    }
    &:focus {
      background: rgba(190, 35, 22, 1);
      color: #f6f6f6;
    }
    &:hover {
      background: rgba(190, 35, 22, 1);
      color: #f6f6f6;
    }
  }
  .active {
    width: 106px;
    height: 40px;
    background: rgba(190, 35, 22, 1);
    color: #f6f6f6;
    border-radius: 4px;
  }
}
/deep/.main-wrap {
  margin-top: 1rem;
  .main {
    width: 1200px;
    margin: 0 auto 1rem;
    border: 1px solid rgba(229, 229, 229, 1);
    box-sizing: border-box;
    .el-form-item {
      padding-left: 20px;
      padding-right: 20px;
      .el-tag {
        margin-right: 1rem;
      }
    }
    .el-form {
      .selected-conditions {
        background-color: #f6f6f6;
        .el-form-item__content {
          display: flex;
          flex-wrap: wrap;
          .el-tag {
            margin-top: auto;
            margin-bottom: auto;
          }
        }
        .clear-conditions {
          cursor: pointer;
          color: #999999;
          align-items: flex-end;
          display: block;
          margin-left: auto;
        }
      }
      .capacity-content {
        .el-form-item__content {
          display: flex;
        }
        .el-input {
          margin-right: 1rem;
          width: 80px;
        }
        .des {
          margin-right: 1rem;
        }
        .el-button-ml {
          background-color: #be2316;
          color: #ffffff;
        }
      }
      /*复选组样式 start*/
      .el-checkbox-button {
        margin-right: 1rem;
      }
      .el-checkbox-button:first-child .el-checkbox-button__inner {
        border-radius: 0 !important;
      }
      .el-checkbox-button:last-child .el-checkbox-button__inner {
        border-radius: 0 !important;
      }
      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        background-color: #be2316;
        border-color: #be2316;
        color: #ffffff;
        box-shadow: -1px 0 0 0 #be2316;
      }
      .el-checkbox-button__inner:hover {
        color: #be2316;
      }
      .el-checkbox-button .el-checkbox-button__inner {
        border: none !important;
      }
      .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
        border-left-color: #be2316;
      }
      /*复选组样式 end*/
      /*单选组样式 start*/
      .el-radio-button {
        margin-right: 1rem;
      }
      .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 0 !important;
      }
      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 0 !important;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #be2316;
        border-color: #be2316;
        color: #ffffff;
        box-shadow: -1px 0 0 0 #be2316;
      }
      .el-radio-button__inner:hover {
        color: #be2316;
      }
      .el-radio-button .el-radio-button__inner {
        border: none !important;
      }
      .el-radio-button.is-checked:first-child .el-radio-button__inner {
        border-left-color: #be2316;
      }
      /*单选组样式 end*/
      .transport-data {
        display: flex;
        .el-input {
          margin-right: 1rem;
        }
        .des {
          margin-right: 1rem;
        }
      }
      .form-item {
        margin-right: 0;
        .form-item-btn {
          background: #be2316;
          border: none;
          i {
            font-size: 14px;
            padding-right: 10px;
          }
        }
      }
    }
  }
  .content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
    .content-img {
      width: 1200px;
    }
    .content-shoucang-tc {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -85px;
      margin-top: -35px;
    }
    .content-baojia {
      position: absolute;
      width: 50px;
      height: 100%;
      right: 0;
      top: 0;
    }
    .content-shoucang {
      position: absolute;
      width: 50px;
      height: 100%;
      right: 50px;
      top: 0;
    }
  }
  /*表格相关*/
  .table-wrap {
    width: 1200px;
    margin: 0 auto;
  }
}
/*/deep/.el-form-item__content{*/
  /*text-align: center;*/
  /*margin-top: 10px;*/
/*}*/
.con{
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 0px;
  padding-bottom: 15px;
  border-bottom: 1px solid #E3E3E3;
  .con-title{
    padding-bottom: 10px;
    color: #F92929;
  }
  .con-box{
    p{
      padding-bottom: 8px;
      line-height: 18px;
    }
  }
}
.quotation-btn{
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  border-radius: 5px;
  background: #BF2317;
  color: #fff;
  &.quotation-btn-xz{
    background: #DE9189;
    color: #F2CCC3;
  }
}
</style>

